import { useEffect } from "react";
import useRegistrationContext from "../../../../hooks/useRegistrationContext";
import { Toaster } from "react-hot-toast";
import "./Registration.css";

const MembershipStatus = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const { data, handleMembershipStatus, handleChange, regularData } =
		useRegistrationContext();

	const content = (
		<>
			<fieldset className="col-sm-12">
				{/* <div className="wrapper-container">
					<legend className="legend-style">
						NDC MEMBERSHIP STATUS
					</legend> */}
					<div className="form-group row">
						<label className="col-sm-3 label-text">
							Are you a Registered NDC Member?
							<span>&nbsp;&nbsp;*</span>
						</label>
						{regularData?.ndcMembership.map((item, index) => (
							<div className="col-sm-2" key={index}>
								<label
									htmlFor={`registered_ndc_member${item.id}`}
								>
									<input
										type="checkbox"
										id={`registered_ndc_member${item.id}`}
										name="membershipNdcMembership"
										checked={
											data.membershipNdcMembership ===
											item.value
										}
										value={item.value}
										onChange={handleMembershipStatus}
									/>
								</label>
								<span className="checkbox-label">
									{item.label}
								</span>
							</div>
						))}
					</div>
					{data.isNdcMember && (
						<div className="form-group row">
							<label
								htmlFor="ndc_membership_number"
								className="col-sm-3 label-text"
							>
								NDC Membership Number<span>&nbsp;&nbsp;*</span>
							</label>
							<div className="col-sm-4">
								<input
									type="text"
									id="ndc_membership_number"
									autoComplete="off"
									required
									style={{
										textTransform: "uppercase",
									}}
									value={data.membershipNdcMembershipNumber}
									name="membershipNdcMembershipNumber"
									onChange={handleChange}
									className="form-control"
								/>
							</div>
						</div>
					)}
					<div className="form-group row">
						<label
							htmlFor="voter_id_number"
							className="col-sm-3 label-text"
						>
							Voter ID Number<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-4">
							<input
								type="text"
								id="voter_id_number"
								autoComplete="off"
								required
								style={{
									textTransform: "uppercase",
								}}
								value={data.membershipVoterIdNumber}
								name="membershipVoterIdNumber"
								onChange={handleChange}
								className="form-control"
							/>
						</div>
					</div>
				{/* </div> */}
			</fieldset>
		</>
	);
	<Toaster toastOptions={{ position: "top-center" }} />;
	return content;
};
export default MembershipStatus;
